import {
  Component,
  inject,
  ChangeDetectionStrategy,
  OnDestroy
} from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { Subject } from 'rxjs';

import { SidebarDisplayStore } from '../../stores/signal-stores/sidebar-display-store/sidebar-display.store';
import { SidebarWrapperComponent } from '../components/sidebar-wrapper/sidebar-wrapper.component';
import {
  SwitchViewSidebarContentComponent
} from './components/switch-view-sidebar-content/switch-view-sidebar-content.component';

@Component({
  selector: 'app-switch-view-sidebar',
  imports: [
    TranslocoDirective,
    SidebarWrapperComponent,
    SwitchViewSidebarContentComponent,
  ],
  templateUrl: './switch-view-sidebar.component.html',
  styleUrl: './switch-view-sidebar.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchViewSidebarComponent implements OnDestroy {
  protected readonly sidebarDisplayStore = inject(SidebarDisplayStore);
  protected primaryActionClicked$ = new Subject<void>();

  public ngOnDestroy(): void {
    this.primaryActionClicked$.complete();
  }

  public onActionButtonClicked(): void {
    this.primaryActionClicked$.next();
  }

  public closeSidebar(): void {
    this.sidebarDisplayStore.hideSwitchViewSidebar();
  }
}
